import moment from 'moment';
import { ColumnDescription } from 'react-bootstrap-table-next';
import { sortCaret } from '../../../../components/table/formatters';
import { tableHeaderText } from '../../../../components/table/TableHeaderFormatter';

export const useColumn = () => {
  const accountingFirmLogColumn: ColumnDescription<any, any>[] = [
    {
      text: tableHeaderText('Date and time'),
      dataField: 'dateTime',
      sort: true,
      sortCaret,
      formatter: (cell) => moment(cell).format('YYYY-MM-DD HH:MM'),
      headerStyle: { width: 104 },
    },
    {
      text: tableHeaderText('User'),
      dataField: 'fullName',
      sort: true,
      sortCaret,
      headerStyle: { width: 110 },
    },
    {
      text: tableHeaderText('Role'),
      dataField: 'role',
      sort: true,
      sortCaret,
      headerStyle: { width: 93 },
    },
    {
      text: tableHeaderText('Category'),
      dataField: 'action',
      sort: true,
      sortCaret,
      headerStyle: { width: 100 },
    },

    {
      text: tableHeaderText('Event'),
      dataField: 'event',
      headerStyle: { width: 160 },
    },
  ];

  return { accountingFirmLogColumn };
};
